import React from 'react'

export default function Contact() {
    return (
        <div className="contact-page">
            <p>Feel free to contact us on <a href="https://twitter.com/gfgdota2">Twitter</a> with any enquiries.</p>
        </div>
    )
}